// extracted by mini-css-extract-plugin
export default {"TrackingInfoRow":"TrackingInfoRow-styles__TrackingInfoRow__rj2Q5"};